/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1LocationStatesIdMutationResponse,
  DeleteApiV1LocationStatesIdPathParams,
  DeleteApiV1LocationStatesId401,
  DeleteApiV1LocationStatesId404,
  DeleteApiV1LocationStatesId409,
  DeleteApiV1LocationStatesId500,
} from "../../types/locationStateController/DeleteApiV1LocationStatesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1LocationStatesId } from "../../clients/locationStateController/deleteApiV1LocationStatesId.ts";

export const deleteApiV1LocationStatesIdMutationKey = () =>
  [{ url: "/api/v1/location/states/:id" }] as const;

export type DeleteApiV1LocationStatesIdMutationKey = ReturnType<
  typeof deleteApiV1LocationStatesIdMutationKey
>;

export function deleteApiV1LocationStatesIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1LocationStatesIdMutationKey();
  return mutationOptions<
    DeleteApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationStatesId401
      | DeleteApiV1LocationStatesId404
      | DeleteApiV1LocationStatesId409
      | DeleteApiV1LocationStatesId500
    >,
    { id: DeleteApiV1LocationStatesIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1LocationStatesId(id, config);
    },
  });
}

/**
 * @description Exclui um estado. Não é permitido excluir estados que possuam cidades vinculadas. **(Requer Authorization para autenticação)**
 * @summary Excluir estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/:id}
 */
export function useDeleteApiV1LocationStatesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1LocationStatesIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1LocationStatesId401
        | DeleteApiV1LocationStatesId404
        | DeleteApiV1LocationStatesId409
        | DeleteApiV1LocationStatesId500
      >,
      { id: DeleteApiV1LocationStatesIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1LocationStatesIdMutationKey();

  const baseOptions = deleteApiV1LocationStatesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationStatesId401
      | DeleteApiV1LocationStatesId404
      | DeleteApiV1LocationStatesId409
      | DeleteApiV1LocationStatesId500
    >,
    { id: DeleteApiV1LocationStatesIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationStatesId401
      | DeleteApiV1LocationStatesId404
      | DeleteApiV1LocationStatesId409
      | DeleteApiV1LocationStatesId500
    >,
    { id: DeleteApiV1LocationStatesIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationStatesId401
      | DeleteApiV1LocationStatesId404
      | DeleteApiV1LocationStatesId409
      | DeleteApiV1LocationStatesId500
    >,
    { id: DeleteApiV1LocationStatesIdPathParams["id"] },
    TContext
  >;
}
